import React from 'react';
import styled from 'styled-components';
import { EuiIcon } from '@elastic/eui';
import FillBar from '../../../../components/metrics/FillBar';
import utilsService from '../../../../../servises/utils.service';

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 4px 0;
`;

const MemorySection = styled.div`
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 8px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  
  .header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .label-group {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 11px;
      color: rgba(255, 255, 255, 0.45);
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      
      .icon {
        color: ${props => props.color || 'rgb(0, 128, 213)'};
        opacity: 0.8;
      }
    }
    
    .value-pct {
      font-size: 14px;
      font-weight: 800;
      color: #fff;
      font-family: Consolas, monospace;
    }
  }
  
  .details-bar {
    margin: 4px 0;
    
    /* Remove sub-margins of legacy styled container */
    & > div {
      margin: 0;
    }
  }
`;

const ServerMemoryWidget = ({ server }) => {
    const memoryTotal = utilsService.getFromMetrics(server, 'ram_total', 0);
    const memoryUsage = utilsService.getFromMetrics(server, 'ram_usage', 0);

    const swapTotal = utilsService.getFromMetrics(server, 'swap_total', 0);
    const swapUsage = utilsService.getFromMetrics(server, 'swap_usage', 0);

    const ramPct = utilsService.getPercent(memoryUsage, memoryTotal) || 0;
    const swapPct = utilsService.getPercent(swapUsage, swapTotal) || 0;

    return (
        <CardWrapper>
            {/* System RAM Card */}
            <MemorySection color="#00cbd6">
                <div className="header-row">
                    <div className="label-group">
                        <EuiIcon type="memory" size="s" className="icon" />
                        <span>System RAM</span>
                    </div>
                    <span className="value-pct">{ ramPct }%</span>
                </div>
                <div className="details-bar">
                    <FillBar
                        total={ server.serverData.ramDataTotal.value }
                        totalUnit={ server.serverData.ramDataTotal.unit }
                        current={ server.serverData.ramDataCurrent.value }
                        currentUnit={ server.serverData.ramDataCurrent.unit }
                        originalTotal={ memoryTotal }
                        originalCurrent={ memoryUsage }
                    />
                </div>
            </MemorySection>

            {/* Swap Space Card */}
            <MemorySection color="#ed8936">
                <div className="header-row">
                    <div className="label-group">
                        <EuiIcon type="storage" size="s" className="icon" />
                        <span>Swap Space</span>
                    </div>
                    <span className="value-pct">{ swapPct }%</span>
                </div>
                <div className="details-bar">
                    <FillBar
                        total={ server.serverData.swapDataTotal.value }
                        totalUnit={ server.serverData.swapDataTotal.unit }
                        current={ server.serverData.swapDataCurrent.value }
                        currentUnit={ server.serverData.swapDataCurrent.unit }
                        originalTotal={ swapTotal }
                        originalCurrent={ swapUsage }
                    />
                </div>
            </MemorySection>
        </CardWrapper>
    );
};

export default ServerMemoryWidget;